<template>
  <generic-modal :title="$t('order')" :buttons="buttons" ref="generic_modal">
    <div>
      <pre>{{ meta }}</pre>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import VLazyImage from "v-lazy-image";
import Attributes from "./Attributes.vue";

export default {
  name: "CreateProductModal",
  components: {
    GenericModal,
    VLazyImage,
    GenericDropdown,
    Attributes,
  },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      api_host,
      buttons: [
        // {
        //   text: this.$t("save"),
        //   class: "is-primary is-rounded",
        //   icon: "fa fa-save",
        //   click: this.save,
        //   disabled: "this.is_form_invalid",
        // },
        {
          text: this.$t("close"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    // is_form_invalid() {
    //   let v = this;
    //   // return false;
    //   return !v.meta.name /* || !v.meta.sale_price */;
    // },
  },
  methods: {
    // change_active_tab,
    // get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(order_uuid) {
      let v = this;
      v.set_initial_state();

      get("/restaurant/order", { uuid: order_uuid })
        .then((order) => {
          v.meta = order;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });

      v.$refs.generic_modal.show_modal();
    },
    // save() {
    //   let v = this;
    //   let data = { ...v.meta };
    //   data.settings.attributes = v.$refs.attributes.get_attributes();
    //   if (!v.meta.uuid)
    //     put("/product", data)
    //       .then(() => {
    //         v.$emit("success");
    //         v.$refs.generic_modal.close_modal();
    //       })
    //       .catch((error) => {
    //         v.error = generate_error_message_text(error);
    //       });
    //   else
    //     post("/product", data)
    //       .then(() => {
    //         v.$emit("success");
    //         v.$refs.generic_modal.close_modal();
    //       })
    //       .catch((error) => {
    //         v.error = generate_error_message_text(error);
    //       });
    // },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
    // error_uploading(error) {
    //   let v = this;
    //   v.error = generate_error_message_text(error);
    // },
    // success_uploading(response) {
    //   let v = this;
    //   let rspnse = JSON.parse(response.serverId);
    //   let data = {
    //     file_id: rspnse.file.file_id,
    //     final_name: rspnse.final_name,
    //     meta: rspnse.file.settings,
    //     original_name: rspnse.file.name,
    //   };
    //   if (v.meta.settings.images) {
    //     v.meta.settings.images.push(data);
    //   } else {
    //     v.meta.settings.images = [data];
    //   }
    // },
    // set_category(categories) {
    //   let v = this;
    //   v.meta.categories = categories;
    // },
  },
  mounted() {},
  watch: {
    // is_form_invalid() {
    //   let v = this;
    //   v.buttons[0].disabled = v.is_form_invalid;
    // },
  },
};
</script>
<style></style>
